import { useQuery, UseQueryOptions } from 'react-query';

import { TeamMember, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useBankContactTeamMembersQuery(
	guid: Guid | undefined,
	userGuid: Guid | null | undefined,
	options?: Omit<UseQueryOptions<TeamMember[], unknown, TeamMember[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoomUsers.TeamMembers(guid, userGuid),
		() =>
			AxiosUtils.getResponseData<TeamMember[]>(
				api.get(CerebroApiEndpoints.DataRoomUsers.TeamMembers(guid, userGuid))
			),
		options
	);
}
